import { createWhatsappRoutes } from "./whatsappConfig"

const whatsappRoutes = createWhatsappRoutes()

export default whatsappRoutes
